(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerDeleteDialogController', ControllerDeleteDialogController);

    ControllerDeleteDialogController.$inject = ['$uibModalInstance','entity','Controller'];

    function ControllerDeleteDialogController($uibModalInstance, entity, Controller) {
        var vm = this;

        vm.controller = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Controller.delete({id:id}, function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
